import { getSystemDb } from '@firesquirrel/local-db';
import { writeAuditLog } from './systemAuditLogService';

export interface SystemRole {
  _id: string;
  name: string;
  code: string;
  description?: string;
  isBuiltIn: boolean;
  status: 'active' | 'disabled';
  permissions: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface OrganizationRole {
  _id: string;
  name: string;
  code: string;
  description?: string;
  isBuiltIn: boolean;
  status: 'active' | 'disabled';
  permissions: string[];
  createdAt?: string;
  updatedAt?: string;
}

export async function listSystemRoles(): Promise<SystemRole[]> {
  const db = await getSystemDb();
  return (db.system_roles as any).table.toArray() as Promise<SystemRole[]>;
}

export async function getSystemRole(id: string): Promise<SystemRole | null> {
  const db = await getSystemDb();
  const doc = await (db.system_roles as any).table.get(id);
  return (doc as SystemRole | undefined) ?? null;
}

export async function upsertSystemRole(data: SystemRole): Promise<void> {
  const db = await getSystemDb();
  const isNew = !(await (db.system_roles as any).table.get(data._id));
  await (db.system_roles as any).table.put({ ...data, updatedAt: new Date().toISOString() });
  writeAuditLog({
    collection: 'systemRoles',
    documentId: data._id,
    action: isNew ? 'create' : 'update',
    summary: isNew ? `Created system role "${data.name}"` : `Updated system role "${data.name}"`,
  }).catch((err) => {
    console.warn('[systemRoleService] Failed to write audit log for system role upsert:', err);
  });
}

export async function listOrganizationRoles(): Promise<OrganizationRole[]> {
  const db = await getSystemDb();
  return (db.organization_roles as any).table.toArray() as Promise<OrganizationRole[]>;
}

export async function getOrganizationRole(id: string): Promise<OrganizationRole | null> {
  const db = await getSystemDb();
  const doc = await (db.organization_roles as any).table.get(id);
  return (doc as OrganizationRole | undefined) ?? null;
}

export async function upsertOrganizationRole(data: OrganizationRole): Promise<void> {
  const db = await getSystemDb();
  const isNew = !(await (db.organization_roles as any).table.get(data._id));
  await (db.organization_roles as any).table.put({ ...data, updatedAt: new Date().toISOString() });
  writeAuditLog({
    collection: 'organizationRoles',
    documentId: data._id,
    action: isNew ? 'create' : 'update',
    summary: isNew ? `Created organization role "${data.name}"` : `Updated organization role "${data.name}"`,
  }).catch((err) => {
    console.warn('[systemRoleService] Failed to write audit log for organization role upsert:', err);
  });
}
